module.exports = __webpack_public_path__ + "img/sand-rock-big-05.d30e2e18.png";